import React, { useRef } from 'react';
import ShareBtn from '../ShareBtn';
import TopicBox from '@/pages/opinion/components/TopicBox';
import { goToFeedsReviewsDetail, objToUrl } from '@/pages/opinion/utils/url';
import { useHistory, useIntl } from 'umi';
import { LanguageType } from '@/pages/opinion/types/common';
import { getContentInfo } from '../../utils.ts';
import './index.scss';
import UpdateSentimentInfoBox from '@/pages/opinion/components/SentimentEditBox';
import { Bubble, Button } from 'tea-component';
import SvgIcon from '@home/components/SvgIcon';

const ReviewsHeader = ({
  data,
  language,
  isActive = false,
  isShowSentiment = true,
  gameInfo,
}: {
  data: any;
  language: LanguageType;
  isActive?: boolean;
  isShowSentiment: boolean;
  gameInfo?: any;
}) => {
  const history = useHistory();
  const { formatMessage } = useIntl();
  // const [topicCond, setTopicCond] = useState([]);
  // useEffect(() => {
  //   if (topicCond.length === 0) {
  //     const filterCond = getFilterCondStorage(gameInfo);
  //     setTopicCond(filterCond?.topic_trans || []);
  //   }
  // }, [gameInfo]);

  const topicList = useRef({ topic_trans: [], key_topic: '' });

  return (
    <div className="dbo-reviews-header">
      <div className="dbo-reviews-header-flex">
        <div className="dbo-title-flex">
          <UpdateSentimentInfoBox data={data}></UpdateSentimentInfoBox>
          <span className="dbo-text">{data.reviewer}</span>
          <span className="dbo-text">{data.comment_time}</span>
          {isActive && (
            <Bubble
              closeOnScroll
              content={formatMessage({ id: 'View details' })}
              dark
            >
              <Button className="dbo-feeds-btn" type="link">
                <SvgIcon
                  type="view-details-icon"
                  onClick={() =>
                    goToFeedsReviewsDetail(history, data, { language })
                  }
                />
              </Button>
            </Bubble>
          )}
          <ShareBtn data={data} text={''} />
        </div>
        {data?.comment_parent_id === '-1' && (
          <Button
            type="link"
            onClick={() => {
              if (data?.content_url) {
                history.push(
                  `/opinion/AIAnalysisHub/URLAnalysis?${objToUrl({
                    gameid: gameInfo.edition_unified_id,
                    content_urls: [encodeURIComponent(data?.content_url)],
                    subTab: 'url',
                  })}`,
                );
              }
            }}
          >
            {formatMessage({ id: 'Post Analysis' })} {'>'}
          </Button>
        )}
      </div>
      <div
        className={`dbo-reviews-header-text ${isActive ? 'active' : ''}`}
        onClick={() => {
          isActive && goToFeedsReviewsDetail(history, data, { language });
        }}
      >
        {getContentInfo(data, language, isShowSentiment)}
      </div>
      <div className="dbo-reviews-header-tab">
        <TopicBox
          topicList={topicList.current}
          noEdit
          needRequest={false}
          showAll
          data={data}
        />
      </div>
    </div>
  );
};

export default ReviewsHeader;
